module.exports = __webpack_public_path__ + "media/images/landing/illust/graph-fans-fd9f1c267d64d4dfe9a19adf4e527aac.png";